// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ANZy","signatureBlock":"Footer_signatureBlock__3m5HI","signature":"Footer_signature__3F-Rk"};